var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create_item_wrap"},[_c('item-write-component',{attrs:{"item-type":'itemCreate'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }